import {differenceInSeconds} from 'date-fns';
import Long from 'long';
import toNumber from '../toNumber';

export default function getDiffToStampInSeconds(stamp?: Long | number | null): number {
  return differenceInSeconds(toNumber(stamp), new Date());
}